import VideoFormModal from "../../components/videos/VideoFormModal";

const Videos = ({
  data,
  setData,
  fetch,
  onClick,
  onChange,
  loading,
  provincias,
  filter,
  setFilter,
  setLoading,
  setVideoToEdit,
  setShowModal,
  showModal,
  videoToEdit,
}) => {
  return (
    <div className="container">
      <div class="d-flex justify-content-between">
        <h1 className="h2 fw-bold">Videos</h1>
        <button
          class="btn btn-custom-naranja text-white"
          name="video"
          onClick={(event) => {
            setVideoToEdit(null);
            setShowModal(true);
          }}
        >
          <i class="fs-8 fw-light bi bi-plus"></i> Agregar video
        </button>
      </div>

      <div className="card px-3 py-3 mb-3">
        <div className="row">
          <div className="col-md-8 col-12 mb-2">
            <label className="fs-8">
              Realiza una busqueda rapida ingresando el titulo del video.
            </label>
            <input
              type="text"
              class="form-control"
              placeholder="Busca tu video"
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
            />
          </div>
          <div class="col-md-4 mb-2">
            <label class="fs-8">Filtrar según estado</label>
            <select
              class="form-select"
              aria-label="Default select example"
              onChange={(e) => {
                if (e.target.value == "TODOS") {
                  let params = filter;
                  delete params["status"];
                  setFilter({ ...params });
                  return fetch(setData, params, "/videos");
                }
                setFilter({ ...filter, status: e.target.value });
                let params = { ...filter, status: e.target.value };
                fetch(setData, params, "/videos");
              }}
            >
              <option value="TODOS">Todos</option>
              <option value="ACTIVO">Activo</option>
              <option value="INACTIVO">Inactivo</option>
            </select>
          </div>
        </div>
      </div>

      <div className="card d-none d-lg-block">
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead className="table-light">
              <tr>
                <th>ID</th>
                <th>TÍTULO</th>
                <th>VIDEO</th>
                <th>AUTOR</th>
                <th>ESTADO</th>
                <th>ACCIONES</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((video) => {
                return (
                  <tr>
                    <td className="fw-semibold">#{video.id}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <img
                          src={`https://www.antesala.com.ar/assets/img/videos/${video.imagen}`}
                          alt="Evento"
                          className="rounded me-3"
                          width="48"
                          height="48"
                        />
                        <span className="fw-medium">{video.titulo}</span>
                      </div>
                    </td>
                    <td>
                      <a className="fs-3" href={video.url}>
                        <i class="bi bi-youtube"></i>
                      </a>
                    </td>
                    <td>{video.usuarios?.nombre}</td>
                    <td>
                      <div className="dropdown">
                        <button
                          className="btn text-dark border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
                          style={{ borderRadius: "10px" }}
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {video.status}
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <label className="btn m-0 p-0">
                              <i className="text-success mx-1 bi bi-check-circle-fill"></i>
                              Activar
                              <button
                                className="d-none"
                                name="status"
                                onClick={(event) =>
                                  onClick(event, {
                                    video: video,
                                    status: "ACTIVO",
                                  })
                                }
                              ></button>
                            </label>
                          </li>
                          <li>
                            <label className="btn m-0 p-0">
                              <i className="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                              Desactivar
                              <button
                                className="d-none"
                                name="status"
                                onClick={(event) =>
                                  onClick(event, {
                                    video: video,
                                    status: "INACTIVO",
                                  })
                                }
                              ></button>
                            </label>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      <label
                        className={`btn btn-sm btn-outline-secondary me-1`}
                      >
                        <i className="bi bi-pencil-square"></i>
                        <button
                          className="d-none"
                          name="editar-evento"
                          onClick={(e) => {
                            setVideoToEdit(video);
                            setShowModal(true);
                          }}
                        ></button>
                      </label>

                      <label className={`btn btn-sm btn-outline-dark`}>
                        <i class="bi bi-ticket"></i>
                        <button
                          className="d-none"
                          onClick={() => {
                            window.location.href = `/dashboard/boleteria/${video.id}`;
                          }}
                        ></button>
                      </label>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className="d-none d-md-flex flex-column flex-sm-row justify-content-between align-items-center mt-4">
        <div className="mb-2 mb-sm-0">
          <small className="text-muted">
            Mostrando <span className="fw-medium">EVENTOS {data?.total}</span>
          </small>
        </div>

        <div>
          {data.links.map((link) => {
            if (link.label == "&laquo; Previous") {
              return (
                <label
                  className={`btn btn-outline-dark me-1 ${
                    link.active ? "active" : ""
                  } ${link.url ? "" : "disabled"}`}
                  onClick={() => {
                    let params = {
                      ...filter,
                      page: data.current_page - 1,
                    };

                    setLoading(true);
                    setFilter({
                      ...params,
                    });

                    fetch(setData, params, "/videos", null, setLoading);
                  }}
                >
                  <i class="bi bi-chevron-left"></i>
                  ANTERIOR
                </label>
              );
            }
            if (link.label == "Next &raquo;") {
              return (
                <label
                  className={`btn btn-outline-dark ${
                    link.active ? "active" : ""
                  } ${link.url ? "" : "disabled"}`}
                  onClick={() => {
                    let params = {
                      ...filter,
                      page: data.current_page + 1,
                    };

                    setLoading(true);
                    setFilter({
                      ...params,
                    });

                    fetch(setData, params, "/videos", null, setLoading);
                  }}
                >
                  SIGUIENTE
                  <i class="bi bi-chevron-right"></i>
                </label>
              );
            }
            return (
              <label
                className={`btn btn-outline-dark me-1 ${
                  link.active ? "active" : ""
                }`}
                onClick={() => {
                  let params = {
                    ...filter,
                    page: link.label,
                  };

                  setLoading(true);
                  setFilter({
                    ...params,
                  });

                  fetch(setData, params, "/videos", null, setLoading);
                }}
              >
                {link.label}
              </label>
            );
          })}
        </div>
      </div>

      <div className="d-flex d-md-none flex-column flex-sm-row justify-content-between align-items-center mt-4">
        <div className="mb-2 mb-sm-0">
          <small className="text-muted">
            Mostrando <span className="fw-medium">EVENTOS {data?.total}</span>
          </small>
        </div>

        <div>
          {data.links.map((link) => {
            if (link.label == "&laquo; Previous") {
              return (
                <label
                  className={`btn btn-outline-dark me-1 ${
                    link.active ? "active" : ""
                  } ${link.url ? "" : "disabled"}`}
                  onClick={() => {
                    let params = {
                      ...filter,
                      page: data.current_page - 1,
                    };

                    setLoading(true);
                    setFilter({
                      ...params,
                    });

                    fetch(setData, params, "/videos", null, setLoading);
                  }}
                >
                  <i class="bi bi-chevron-left"></i>
                </label>
              );
            }
            if (link.label == "Next &raquo;") {
              return (
                <label
                  className={`btn btn-outline-dark ${
                    link.active ? "active" : ""
                  } ${link.url ? "" : "disabled"}`}
                  onClick={() => {
                    let params = {
                      ...filter,
                      page: data.current_page + 1,
                    };

                    setLoading(true);
                    setFilter({
                      ...params,
                    });

                    fetch(setData, params, "/videos", null, setLoading);
                  }}
                >
                  <i class="bi bi-chevron-right"></i>
                </label>
              );
            }

            return (
              <label
                className={`btn btn-outline-dark me-1 ${
                  link.active ? "active" : ""
                }`}
                onClick={() => {
                  let params = {
                    ...filter,
                    page: link.label,
                  };

                  setLoading(true);
                  setFilter({
                    ...params,
                  });

                  fetch(setData, params, "/videos", null, setLoading);
                }}
              >
                {link.label}
              </label>
            );
          })}
        </div>
      </div>

      <VideoFormModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={onClick}
        video={videoToEdit}
        provincias={provincias}
      />
    </div>
  );
};

export default Videos;
